import React from "react";

//Components
import Modal from "components/shared/Modal";
import InstallDialogAction from "./InstallDialogAction";
import logoPng from "assets/images/logo.png";
export default function InstallDialog(props) {
    return (
        <Modal showModal={props?.open}>
            <h3>{props?.title || "نصب اپلیکیشن"}</h3>
            <div>
                <div>
                    {!!props.logo && <img src={logoPng} style={{width:60}} alt="logo" />}
                    {!!props.features && (
                        <div>
                            <h4>ویژگی های کلیدی :</h4>
                            <p>{props.features}</p>
                        </div>
                    )}
                </div>
                {!!props.description && (
                    <>
                        <h4 className="">توضیحات : </h4>
                        <p>{props.description}</p>
                    </>
                )}
            </div>
            <InstallDialogAction platform={props.platform} onSubmit={props.onSubmit} onClose={props.onClose} />
        </Modal>
    );
}
